export default {
  "common": {
    "participate": "Participer maintenant",
    "home": "Accueil",
    "contact": "Contact",
    "how_it_works": "Comment ça marche",
    "winners": "Gagnants",
    "good_cause": "Bonne cause",
    "account": "Mon compte",
    "logout": "Déconnexion"
  },
  "home": {
    "hero": {
      "grand_prize": "Grand prix du tirage #52",
      "villa_title": "La villa qui pourrait changer votre vie",
      "estimated_value": "Valeur estimée",
      "win_your": "Gagnez votre",
      "dream_house": "Maison de Rêve",
      "description": "Une villa moderne de 500 m² évaluée à {{value}} à gagner, plus des dizaines de lots exceptionnels.",
      "buy_tickets": "Acheter mes tickets",
      "see_prizes": "Voir les lots",
      "prizes": {
        "title": "Plus de 1 200 000 € de lots à gagner",
        "description": "Une vie de rêve vous attend. Tentez votre chance dès aujourd'hui."
      }
    },
    "property": {
      "tabs": {
        "exterior": "Extérieur",
        "interior": "Intérieur",
        "land": "Terrain"
      },
      "features": {
        "surface": "Surface",
        "bedrooms": "Chambres",
        "bathrooms": "Salles de bain",
        "pool": "Piscine & Spa",
        "garden": "Jardin",
        "garage": "Garage"
      }
    }
  },
  "admin": {
    "title": "Administration Loto",
    "manage_lottery": "Gérer la loterie",
    "manage_packages": "Gérer les forfaits",
    "manage_prizes": "Gérer les lots",
    "users": "Utilisateurs",
    "settings": "Paramètres du site"
  }
};
